import {Component, NgModule, OnInit} from '@angular/core';
import {MatDialog} from '@node_modules/@angular/material';
import {Router} from '@node_modules/@angular/router';
import {Subscription} from '@models/subscription';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {User} from '@models/user';
import {AccountService} from '@services/account/account.service';
import {Program} from '@models/program';


@Component({
  selector: 'app-subscription-students-list-popup',
  templateUrl: './subscription-students-list-popup.component.html',
  styleUrls: ['./subscription-students-list-popup.component.scss']
})

export class SubscriptionStudentsListComponent implements OnInit {
  static modalRef;
  static subscription: Subscription;
  static program: Program;

  students = [];

  constructor(
    public dialog: MatDialog,
    private subscriptionService: SubscriptionService,
    private accountService: AccountService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const subscription = SubscriptionStudentsListComponent.subscription;
    const program = SubscriptionStudentsListComponent.program;

    if (subscription && subscription.id) {
      this.subscriptionService
        .getSubscriptionUsersList(subscription.id, program.id)
        .subscribe((resp: {data: []}) => {
          this.students = resp.data;
        });
    }
  }

  close() {
    SubscriptionStudentsListComponent.modalRef.close();
  }

  toStudentPage(studentId) {
    this.accountService.getUserById(studentId).subscribe(
      (resp: { data: User }) => {
        this.close();
        localStorage.setItem('openUserProfile', JSON.stringify(resp.data));
        this.router.navigate(['/students']);
      }
    );
  }
}
